/* eslint-disable @next/next/no-img-element */
// use img tag not Image from next is Image from next set overflow hidden and cannot be remove
import Image from 'next/image';
import { memo, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getDoccoin } from '../../../apis/reward.api';
import { PATH_NAME } from '../../../configs/pathName';
import { DOCCOIN } from '../../../constant/QueryKeyName';
import { useRouter } from 'next/router';

const renderDoccoinLevel = (
  doccoin?: number
): {
  icon: React.ReactElement;
  level: 'bronze' | 'silver' | 'gold' | 'diamond';
  title: string;
} => {
  if (!doccoin) {
    return {
      icon: (
        <img src="/img/bronze.png" alt="bronze icon" width={32} height={32} />
      ),
      level: 'bronze',
      title: 'Hạng Đồng',
    };
  }
  return doccoin >= 1000 && doccoin < 10000
    ? {
        icon: (
          <img src="/img/silver.png" alt="silver icon" width={32} height={32} />
        ),
        level: 'silver',
        title: 'Hạng Bạc',
      }
    : doccoin >= 10000 && doccoin < 100000
    ? {
        icon: (
          <img src="/img/gold.png" alt="gold icon" width={32} height={32} />
        ),
        level: 'gold',
        title: 'Hạng Vàng',
      }
    : doccoin >= 100000
    ? {
        icon: (
          <img
            src="/img/diamond.png"
            alt="diamond icon"
            width={32}
            height={32}
          />
        ),
        level: 'diamond',
        title: 'Hạng Kim Cương',
      }
    : {
        icon: (
          <img src="/img/bronze.png" alt="bronze icon" width={32} height={32} />
        ),
        level: 'bronze',
        title: 'Thành viên Đồng',
      };
};

const CoinReward = () => {
  // const doccoin: number = 10000; //get query doccoin here

  const { data: doccoin } = useQuery<{ data: any }, Error, number>(
    DOCCOIN,
    getDoccoin,
    {
      refetchOnMount: true,
      select: (data) => +data.data.totalDoccoin,
    }
  );
  const { icon, title, level } = useMemo(
    () => renderDoccoinLevel(doccoin),
    [doccoin]
  );
  const router = useRouter();

  const titleTextColor = () =>
    level === 'bronze'
      ? 'text-cooper'
      : level === 'silver'
      ? 'text-silver'
      : level === 'gold'
      ? 'text-gold'
      : 'text-diamond';

  return (
    <div className="flex items-center justify-between p-4 bg-white rounded-[10px] shadow-[0px_10px_20px_rgba(0,0,0,0.05)] mb-10">
      <div className="flex gap-3 items-center">
        <div className="">{icon}</div>
        <div className="h-full w-auto flex flex-col justify-center">
          <h6
            className={`${titleTextColor()} font-semibold text-base leading-[140%] tracking-[-0.3px] text-black`}
          >
            {title}
          </h6>
          <div className="text-black flex gap-[2px]">
            <Image
              src="/img/doccoin.svg"
              alt="doccoin icon"
              width={15}
              height={15}
            />
            <span className="inline-block flex-1 font-normal text-xs tracking-[-0.03em] truncate">
              {doccoin}
            </span>
          </div>
        </div>
      </div>
      <div
        onClick={() => router.push(PATH_NAME.REWARD)}
        className="justify-self-end w-fit"
      >
        <p className="text-[#0086C9] font-semibold text-sm leading-4 tracking-[-0.1px] cursor-pointer hover:underline">
          Xem điểm
        </p>
      </div>
    </div>
  );
};

export default memo(CoinReward);
